import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { jsxs, jsx } from 'react/jsx-runtime.js';
import React__default from 'react';
import cn from 'classnames';
import styles from './SourceTabs.module.css.js';

var SourceTabs = /*#__PURE__*/React__default.memo(function (props) {
  var options = props.options,
    selected = props.selected,
    onSelectTab = props.onSelectTab,
    className = props.className;
  var onClick = function onClick(e) {
    var _e$currentTarget$getA;
    onSelectTab((_e$currentTarget$getA = e.currentTarget.getAttribute('data-id')) !== null && _e$currentTarget$getA !== void 0 ? _e$currentTarget$getA : '');
  };
  return jsxs("div", {
    className: styles.container,
    children: [jsx("ul", {
      className: cn(styles.list, className),
      children: options.map(function (option) {
        return jsx("li", {
          className: cn(styles.option),
          title: option.tooltip,
          children: jsx("button", {
            "data-id": option.id,
            className: cn(styles.button, _defineProperty({}, styles.selected, selected === option.id)),
            onClick: onClick,
            children: jsx("span", {
              className: styles.content,
              tabIndex: -1,
              children: option.title
            })
          }, option.id)
        }, option.id);
      })
    }), jsx("div", {
      className: styles.tail
    })]
  });
});

export { SourceTabs };
